export default  {
  ZipMatch: "ZipMatch",
  SuiteMatch: "SuiteMatch",
  BusNameMatch: "BusNameMatch",
  PartialBusNameMatch: "PartialBusNameMatch",
  CityMatch: "CityMatch",
  StateMatch: "StateMatch",
  StreetMatch: "StreetMatch",
  WebsiteMatch: "WebsiteMatch",
  PhoneMatch: "PhoneMatch",
  NoAltPhone: "NoAltPhone",
  AltPhoneMatch: "AltPhoneMatch",
  Partial: "Partial",
  HoursMatch: "HoursMatch"
}
